<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    height="24"
    width="24"
  >
    <g>
      <path
        d="M16.73 18.29a1 1 0 0 0 -0.17 2 29.16 29.16 0 0 1 3.77 0.52 0.25 0.25 0 0 1 0 0.49A39.87 39.87 0 0 1 12 22a39.87 39.87 0 0 1 -8.33 -0.71 0.25 0.25 0 0 1 0 -0.49 28.86 28.86 0 0 1 3.73 -0.52 1 1 0 0 0 0.91 -1.08 1 1 0 0 0 -1.08 -0.91C0 18.9 0 20.4 0 21c0 2.67 8.32 3 12 3s12 -0.29 12 -3c0 -0.6 0 -2.1 -7.27 -2.71Z"
        :fill="colour"
        stroke-width="1"
      ></path>
      <path
        d="M12 21.6a1 1 0 0 0 0.84 -0.46c2 -3.06 6.52 -10.53 6.52 -13.78a7.36 7.36 0 0 0 -14.72 0c0 3.25 4.56 10.72 6.52 13.78a1 1 0 0 0 0.84 0.46ZM8.5 7a3.5 3.5 0 1 1 3.5 3.5A3.5 3.5 0 0 1 8.5 7Z"
        :fill="colour"
        stroke-width="1"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
    props: {
        colour: {
        type: String,
        default: '#FE2121',
        },
    },
};
</script>

<style>
</style>